export default __webpack_public_path__ + "static/ukpai-e14f16dcec3157fee4f0bea0435f069c.png";